import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    imports: [
        ReactiveFormsModule,
        RouterLink,
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('emailInput') emailInput!: ElementRef;

  toggled = true;
  pswVisibility = 'password';

  loginForm = new FormGroup({
    email: new FormControl<null | string>(null, [Validators.required, Validators.email]),
    password: new FormControl<null | string>(null, Validators.required)
  })

  hasError = false;

  constructor(private authUser: AuthService, public router: Router) { }

  ngOnInit(): void {
    if (this.authUser.isLoggedIn()) {
      this.router.navigate(['home']);
    }
  }

  ngAfterViewInit(): void {
    this.emailInput.nativeElement.focus();
  }

  async checkAccess() {
    if (this.loginForm.get('email')?.valid && this.loginForm.get('password')?.valid) {
      try {
        await this.authUser.loginUser(this.loginForm.get('email')?.value!, this.loginForm.get('password')?.value!);
        if (this.authUser.getToken() != null) {
          this.hasError = false;
          window.location.href = '/home';
        }
      } catch (error) {
        this.hasError = true;
        console.error('Login failed', error);
      }
    }
  }

  seePassword() {
    if (this.toggled) {
      this.pswVisibility = 'text';
    } else {
      this.pswVisibility = 'password';
    }
    this.toggled = !this.toggled;
  }

  checkEmail() {
    const email_val = this.loginForm.get('email')?.value;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email_val!)) {
      this.loginForm.setErrors(null);
    }
    else {
      this.loginForm.setErrors({ invalid: true });
    }
  }
}
